import React from 'react'

export default function Footer() {
	return (
		<>
			<footer>
				<div className="citation">&copy; ALL RIGHTS RESERVED <cite>- Sky deep</cite></div>
			</footer>
		</>
	)
}